import ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { InjectionToken } from "tsyringe";

import { createModalToken } from "@components/Modal/ModalManager";
import { LoggerInterface } from "@interfaces/LoggerInterface";

export const instagramApplicationLoggerToken = Symbol(
    "InstagramApplication__LoggerToken"
) as InjectionToken<LoggerInterface>;

export const instagramAuthApiClientToken = Symbol(
    "instagramAuthApiClientToken"
) as InjectionToken<ApiClientInterface>;

export const instagramAuthApiV3ClientToken = Symbol(
    "instagramAuthApiV3ClientToken"
) as InjectionToken<ApiClientInterface>;

export const instagramStoriesModalToken = createModalToken<{ id: number }>(
    "InstagramStoriesModal"
);
